import styled, { css } from "styled-components";

export const CreateDomainStyles = css`
  flex-direction: row-reverse;
  gap: 10px;
  color: var(--primary-dark-300);
  font-family: Rubik;
  font-size: 0.857rem; // 12px
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  padding: 10px 0px;

  > svg {
    color: var(--primary-blue);
    stroke-width: 1.6;
  }

  &:hover {
    color: var(--primary-blue);
  }

  && {
    width: fit-content;
  }
`;

export const OptionBtn = styled.button`
  cursor: pointer;
  text-align: center;
  border-width: 1px;
  border-style: solid;
  border-color: var(--primary-dark-200);
  border-radius: 5px;
  color: var(--primary-blue);
  background-color: var(--primary-dark-100);
  display: grid;
  place-items: center;
  width: 100%;
  font-family: Rubik, sans-serif;
  font-size: 1rem;
  line-height: 17px;
  min-height: 29px;
  padding: 6px 10px;
  font-weight: 400;
  font-style: normal;
  transition: all 0.3s;

  .text-content,
  .loading-content {
    grid-area: 1 / 1;
    transition: transform 0.3s ease, opacity 0.2s ease;
  }

  /* Default state: show text, hide loading */
  .text-content {
    opacity: 1;
  }

  .loading-content {
    opacity: 0;
  }

  /* Loading state: hide text, show loading */
  ${({ $isLoading }) =>
    $isLoading &&
    css`
      .text-content {
        opacity: 0;
      }

      .loading-content {
        opacity: 1;
      }
    `}

  &:hover {
    background-color: var(--primary-dark-200);
    border-color: var(--primary-blue);
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: var(--primary-white);
      background-color: var(--primary-blue);

      &:hover {
        background-color: var(--primary-blue-hover);
      }
    `}

  &:disabled {
    cursor: ${({ $canGrab }) => ($canGrab ? "grab" : "default")};
    color: var(--primary-dark-200);
    border-color: var(--primary-dark-200);
    background-color: var(--primary-dark-100);

    &:hover {
      border-color: var(--primary-dark-200);
      background-color: var(--primary-dark-100);
    }
  }
`;

export const OptionsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px 35px;
`;

export const DeleteButton = styled.button`
  display: grid;
  place-content: center;
  border: none;
  background-color: transparent;
  color: var(--primary-grey);
  font-size: 1rem;
  font-family: Rubik;
  padding: 2px;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.2s ease;

  position: absolute;
  top: 0;
  right: -20px;

  &:hover {
    background-color: var(--primary-red);
    color: var(--primary-white);
  }
`;

export const OptionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const BodyContainer = styled.div`
  width: 100%;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const NoSkillsText = styled.p`
  font-size: 1rem;
  color: var(--primary-dark-400);
`;
